export const customShadow = `shadow-[0px_0.42vw_0.52vw_0px_#0000000F] max-lg:shadow-[0px_1.6vw_2vw_0px_#0000000F]`;
export const buttonShadow = `shadow-[0px_0.14vw_0.28vw_rgba(0,0,0,0.05)] max-lg:shadow-[0px_0.53vw_1.06vw_rgba(0,0,0,0.05)]`;

export const mainCardGradient = `before:content-[''] before:absolute before:inset-0 before:p-[0.07vw] before:!rounded-[1.94vw]
 before:[background:linear-gradient(121deg,rgba(255,255,255,1)_0%,rgba(221,224,235,1)_100%)] max-lg:!rounded-[5.33vw]
  max-lg:before:!rounded-[5.33vw] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor]
  before:[mask-composite:exclude] before:z-[1] before:pointer-events-none`;

export const mainIconGradient = `relative before:content-[''] before:absolute before:inset-0 before:p-[0.07vw] 
before:!rounded-full !rounded-full  before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)] 
before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor]
 before:[mask-composite:exclude] before:z-[1] before:pointer-events-none`;

export const buttonGradient = `relative before:content-[''] before:absolute before:inset-0 before:p-[0.07vw]
 before:rounded-[6.94vw] before:[background:linear-gradient(101.62deg,#FFFFFF_0%,rgba(255,255,255,0)_100%)] 
 before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor]
  before:[mask-composite:exclude] before:pointer-events-none before:z-[1]`;

export const borderClassGradient = `relative 
  before:content-[''] before:absolute before:inset-0 
  
  before:p-[0.104vw] before:rounded-[1.25vw] 
  
  max-lg:before:p-[0.2667vw] max-lg:before:rounded-[3.2vw]
  
  before:[background:linear-gradient(101.62deg,#FFFFFF_0%,rgba(255,255,255,0)_100%)] 
  before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] 
  before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] 
  before:pointer-events-none before:z-[1]`;
